import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'

const size = {
  ctTablet: '728px',
  desktop: '1440px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1201px',
  xxm: '1359.98px',
  xxl: '1499px',
  mobile: '480px',
  smMax: '575.98px',
  tablet: '727px',
  mdMax: '767.98px',
  lgMax: '991.98px',
  xxmMax: '1439px',
  xlMax: '1200.98px',

  xxlMax: '1499px',
}
const newDark = {
  font: {
    default: 'Gilroy',
  },
  colors: {
    darkBlue: '#0E2864',
    darkestBlue: '#08204f',
    cyanBlue: '#00e0ff',
    paleNavy: '#ced2dc',
    vividBlue: '#3071EE',
    navy: '#1C4CB5',
    brightnessNavy: '#2D54DE',
    brightRed: '#FF5E60',
    lightGrayishNavy: '#6B7B9F',
    brightNavy: '#1743A7',
    white: '#FFFFFF',
    paleWhite: '#F3F7FD',
    softNavy: '#324875',
    darkNavy: '#051847',
    brightGreen: '#51DDB9',
    deepBlue: '#10316f',
  },
}

const newLight = {
  font: {
    default: 'Gilroy',
  },
  colors: {
    ...newDark.colors,
    lightBlue: '#91B4F6',
    lightWhite: '#f8fafe',
    loginBtnCollor: '#eaf1fd',
  },
}

export const light = {
  isDark: false,
  font: {
    default: 'Open Sans',
    gilroy: 'Gilroy',
  },
  fontSize: {
    smXs: '0.65rem',
    xs: '0.75rem',
    xsSm: '0.8125rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    xxl: '2.375rem',
    '1.3xl': '1.3125rem',
    '1.5xl': '1.375rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem',
  },
  fontWeight: {
    hairline: '100',
    thin: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },

  colors: {
    newLightColor: { ...newLight.colors },
    newDarkColor: { ...newDark.colors },
    lightBlue: '#C0D8FF',
    white: '#ffffff',
    default: '#131622',
    black: '#000000',
    link: '#3071ee',
    muted: '#7a849d',
    linkHover: '#104dc2',
    border: '#e5eaf9',
    warnText: '#ed6a21',
    warnBg: 'rgba(237,106,33,.23)',
    navLinkBorder: '#c9d0e3',
    defaultButtonColor: '#131622',
    loginButtonBg: 'rgba(48,113,238,.1)',
    loginButtonBgHover: 'rgba(48,113,238,.2)',
    loginButtonBorder: '#2960f6',
    startButtonBgHover: '#1a5cdc',
    startButtonBorderHover: 'rgba(48,113,238,.3)',
    boxShadow: 'rgb(120 131 159 / 14%)',
    dropdownItem: '#212529',
    dropdownItemHover: 'rgba(48, 113, 238, 0.1)',
    asideSmall: '#f9fafe',
    footer: '#4e5155',
    opacity: 'rgba(0, 0, 0, 0.1)',
    menu: '#111',
    menuBG: 'rgba(19, 22, 34, 0)',
    asidBg: '#f9f9f9',
    asideTogle: 'rgba(19, 22, 34, 0.2)',
    borderTable: '#dee2e6',
    thBackground: '#f4f7fd',
    lightLink: '#e4ecfc',
    menuHeader: '#131621',
    menuNumber: '#3E73E6',
    menuNumberBG: '#EBF1FC',
    separator: '#E7EBF8',
    eth: '#F5A32E',
    imgBorder: '#CAD0E1',
    category: '#F6F9FF',
    reset: 'rgba(122, 132, 157, 1)',
    locale: '#7C849B',
    placeholder: '#7D859B',
    tag: '#626E8A',
    tagActive: '#3071EE',
    defaultBlack: '#131621',
    tabBg: '#F5F7FA',
    cardNumberBg: '#598DF1',
    cryptoCardOption: '#EEF4FF',
    green: '#19A33E',
    targetBorder: '#568BF0',
    emailBorder: '#9ab9f6',
    cardShadow: '#d6e3fc',
    alertLinkBorder: 'rgba(98, 110, 138, 0.2)',
    faqBorder: '#E0E2E8',
    error: 'rgba(220, 56, 39, 0.1)',
    error2: 'rgba(220, 56, 39, 1)',
    stakingBg: '#0c275f',
    stakingFooterBg: '#08204f',
    lockBg: '#eef4fe',
  },
  device: {
    ctTablet: `(min-width: ${size.ctTablet})`,
    desktop: `(min-width: ${size.desktop})`,
    ctTabletMax: `(max-width: ${size.ctTablet})`,
    sm: `(min-width: ${size.sm})`,
    md: `(min-width: ${size.md})`,
    lg: `(min-width: ${size.lg})`,
    xl: `(min-width: ${size.xl})`,
    xxm: `(min-width: ${size.xxm})`,
    xxl: `(min-width: ${size.xxl})`,
    mobile: `(max-width: ${size.mobile})`,
    smMax: `(max-width: ${size.smMax})`,
    sMax: `(max-width: ${size.smMax})`,
    tablet: `(max-width: ${size.tablet})`,
    mdMax: `(max-width: ${size.mdMax})`,
    lgMax: `(max-width: ${size.lgMax})`,
    xlMax: `(max-width: ${size.xlMax})`,
    maxXl: `(max-width: ${size.xl})`,
    xxmMax: `(max-width: ${size.xxm})`,
    xxlMax: `(max-width: ${size.xxlMax})`,
  },
}

export const lightTheme = {
  isDark: false,
  colors: { ...newLight },
}
export const darkTheme = {
  isDark: false,
  colors: { ...newDark },
}

export type ThemeType = typeof theme

export const GlobalStyle = createGlobalStyle`
  ${reset}
  *, *:before, *:after {
    box-sizing: border-box;
  }
  html {
    box-sizing: border-box;
    font-family: 'Gilroy';
    
  }
  body {
    font-family: 'Open Sans';
    height:100vh;
    margin:0;
    line-height: 1.5;
    font-size: '0.65rem';
    color: '#131622';
    font-weight: '400';
    font-display: fallback !important;

    overflow-x: hidden;
    
    input[type=search]::-ms-clear { display: none; width : 0; height: 0; }
    input[type=search]::-ms-reveal { display: none; width : 0; height: 0; }
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration { display: none; }
    
    .ReactModal__Body--open {
      overflow: hidden;
    }
  }
  body.index-page {
    overflow-y: auto;
    overflow-y: overlay;
  }
  body.index-page .intercom-lightweight-app-launcher {
    display: none !important;
  }
  body.index-page.overflow .intercom-lightweight-app-launcher {
    display: none !important;
  }
  
  .intercom-lightweight-app-launcher {
    display: none !important;
  }
  
  .overflow {
    overflow: hidden;
  }
  body.index-page footer {
    @media (max-width: ${size.lgMax}) {
      padding-bottom: 50px;
    }
  }
  
  a {
    color: '#3071ee';
    text-decoration: none;
    background-color: transparent;
  }
  img {
    vertical-align: middle;
    border-style: none;
  }
  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }
  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
  }
  tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
  }
  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }
  td {
    display: table-cell;
  }
  ul {
    padding-inline-start: 0;
    margin-bottom: 0;
    list-style: none;
  }
  textarea:focus, input:focus{
    outline: none;
  }
  *:focus {
    outline: none;
  }
  
  * {
    -webkit-tap-highlight-color: transparent;
  }
  
  .staticImage {
    width: 100%;
    flex-basis: 50%;
  }
  `
// export interface Theme extends DefaultTheme {
//   isDark: boolean
// }
export const theme = light
